import React from 'react';
import { useClearRefinements, useInstantSearch } from 'react-instantsearch';
export default function ClearRefinements({ clearRefinementsComponent: ClearRefinementsComponent, clearRefinementsSettings, additionalData, }) {
    const clearRefinementsProps = useClearRefinements(clearRefinementsSettings);
    const { results } = useInstantSearch();
    return (React.createElement(ClearRefinementsComponent, { results: results, clearRefinements: clearRefinementsProps, clearRefinementsSettings: clearRefinementsSettings, additionalData: additionalData }));
}
